<template>
  <div
    :class="{
      'router-select_active': active,
      'router-select-view-wrap': true,
    }"
    @click="openView"
  >
    <span v-if="options.length" class="router-select-text">{{ valueShow }}</span>
    <span v-else class="router-select-placeholder">{{ _placeholder }}</span>
  </div>
</template>

<script>
/* eslint-disable vue/require-default-prop, vue/require-prop-types */
export default {
  components: {},
  props: {
    options: {
      default: () => [],
    },
    placeholder: {},
    active: {
      type: Boolean,
      default: false,
    },
    dialog: {
      type: Number,
      default: 0,
    },
    value: {},
    url: {},
  },
  data() {
    return {}
  },
  computed: {
    _placeholder() {
      return this.placeholder || ''
    },
    valueShow() {
      const temp = this.options.map(el => el.itemName)
      return temp.join(',  ')
    },
  },

  watch: {},
  methods: {
    openView() {
      const shopId = this.$route.query && this.$route.query.shopId
      if (!this.dialog) {
        this.showDatePicker()
      } else {
        this.$router.push({
          path: this.url,
          query: {
            shopId,
          },
        })
      }
    },
    showDatePicker() {
      // 弹出文案提示的确认
      this.$createDialog({
        icon: 'richic-alert',
        content: this.$t(
          'FoodB_up20241218_hGVF_hBSj' /** 当前商家没有符合条件的菜品，建议你联系商家尽快上传菜品 */,
        ),
        confirmBtn: {
          text: this.gettext('我知道了'),
          active: true,
          disabled: false,
          href: 'javascript:;',
        },
      }).show()
    },
  },
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
